import { useState } from 'react';
import api from '../../api/index.js';
import s from './PriceSources.module.scss';
import Popup from '../../components/Popup/Popup.jsx';
import Input from '../../components/Input/Input.jsx';
import pencilIcon from '../../assets/icons/pencilIcon.js';
import { formatDateMsk } from '../../utils/date.js';

const PriceSourceItem = ({ item, onUpdated }) => {
  const [popupShowed, setPopupShowed] = useState(false);
  const [loading, setLoading] = useState(false);
  const [priceApi, setPriceApi] = useState(item.price_api || '');
  const [comment, setComment] = useState(item.comment || '');
  const [error, setError] = useState('');

  const openPopup = () => {
    setPriceApi(item.price_api || '');
    setComment(item.comment || '');
    setError('');
    setPopupShowed(true);
  };

  const closePopup = () => {
    setPopupShowed(false);
  };

  const handleSave = async () => {
    const body = {};
    if (priceApi !== item.price_api) body.price_api = priceApi;
    if (comment !== item.comment) body.comment = comment;
    if (Object.keys(body).length === 0) {
      setPopupShowed(false);
      return;
    }
    setLoading(true);
    setError('');
    const data = await api.priceSources.patch(item.brand_id, body);
    setLoading(false);
    if (data.error) {
      setError(data.error);
      return;
    }
    onUpdated({ ...item, ...body });
    setPopupShowed(false);
  };

  return (
    <li className={s.item}>
      <div className={s.itemInfo}>
        <span className={s.brandName}>{item.brand_name}</span>
        <span className={s.priceApi}>{item.price_api}</span>
        {item.comment && <span className={s.comment}>{item.comment}</span>}
        <span className={s.dates}>
          {item.updated_at && item.updated_at !== item.created_at && (
            <span>Изменён: {formatDateMsk(item.updated_at)}</span>
          )}
        </span>
      </div>
      <button className={s.editBtn} onClick={openPopup}>
        {pencilIcon}
      </button>

      {popupShowed && (
        <Popup
          close={closePopup}
          title="Изменить источник"
          loading={loading}
        >
          <div className={s.form}>
            <Input
              label="API источник"
              val={priceApi}
              setVal={setPriceApi}
              placeholder="например: api_equip"
            />
            <Input
              label="Комментарий"
              val={comment}
              setVal={setComment}
              placeholder="например: СТМ"
            />
            {error && <p className={s.error}>{error}</p>}
            <button className="btn" onClick={handleSave}>
              Сохранить
            </button>
          </div>
        </Popup>
      )}
    </li>
  );
};

export default PriceSourceItem;
